import { useEffect } from 'react';
import { useTenant } from '../contexts/TenantContext';

/**
 * Hook to dynamically update favicon and page title based on selected grampanchayat
 */
export function useDynamicFaviconAndTitle() {
  const { tenantData } = useTenant();

  useEffect(() => {
    let faviconLink = document.querySelector('link[rel="icon"]');
    if (!faviconLink) {
      faviconLink = document.createElement('link');
      faviconLink.rel = 'icon';
      document.head.appendChild(faviconLink);
    }
    faviconLink.type = 'image/x-icon';
    faviconLink.href = '/favicon.ico?v=ashoka-1';

    if (tenantData?.tenant) {
      const { name } = tenantData.tenant;

      // Update page title
      if (name) {
        document.title = name;
      }
    }
  }, [tenantData]);
}
